import React from 'react';
type GoldPlaqueProps = {
  children: React.ReactNode;
  tone?: 'dark' | 'light';
};
export function GoldPlaque({
  children,
  tone = 'light'
}: GoldPlaqueProps) {
  return <p className={`inline-flex items-center gap-2.5 rounded-md border px-4 py-2 text-[12px] font-bold uppercase tracking-[0.16em] sm:text-[13px] ${tone === 'dark' ? 'border-gold/60 bg-gold/10 text-gold' : 'border-gold-dark/50 bg-cream text-gold-ink'}`} data-id="element-623" data-mp="11ik1a6was5ry">
      <span aria-hidden="true" className={`h-3 w-1.5 -skew-x-12 ${tone === 'dark' ? 'bg-gold' : 'bg-gold-dark'}`} data-id="element-624" data-mp="9pb0mchsswjp" />
      {children}
    </p>;
}